// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2zXlT","productName":"Table_productName__1F5Jz"};